<template lang="html">

  <section class="otros-lugares">

    <h2 class="title -ghost container" v-html="$t('otras_experiencias.titulo')"></h2>

    <div class="lugares-list row-center">


      <template v-for="(el, key) in $t('otras_experiencias.lugares')">

        <article :data="key" :class="['lugar-el row-center plum-border']"  v-if="key != urlName">
          <router-link :to="$t(`enlaces.${[key]}`)" class="enlace-cover"></router-link>
          <router-link :to="$t(`enlaces.${[key]}`)" class="btn"><span>{{el}}</span></router-link>
        </article>

      </template>

    </div>

  </section>

</template>

<script lang="js">
  export default  {
    name: 'otros-lugares',
    computed : {
      urlName : function(){
        return this.$route.name;
      }
    }
  }
</script>

<style scoped lang="scss">

@import "@/assets/css/colors.scss";


.otros-lugares {
  background: $plum;
  padding-top: 50px;
}

.lugares-list{
  position: relative;
}

.title.-ghost{
  text-align: left;
  line-height: 1em;
  margin-bottom: 0;
  padding-bottom: 0;
  z-index: 3;
  transition: 1s;
}

.lugar-el{
  width: 25%;
  height: 33.3333vw;
  max-height: 500px;
  position: relative;
  z-index: 2;
  opacity: 0;
  transition: 2s;

  .btn{
    transform: translateY(-200px);
    opacity: 0;
    transition: 1s;
    transition-delay: .8s;
  }
}


@for $i from 1 through 9{
  .lugar-el:nth-child(#{$i}){
    transition-delay: #{$i / 5 + .8}s;
  }
}

.lugar-el[data=enoturismo]{
  background: url(/static/img/banner-enoturismo.jpg) center/cover no-repeat;
}

.lugar-el[data=oleoturismo]{
  background: url(/static/img/banner-oleoturismo.jpg) center/cover no-repeat;
}

.lugar-el[data=ruta_cervantina]{
  background: url(/static/img/banner-ruta-cervatina.jpg) center/cover no-repeat;
}

.lugar-el[data=recetario]{
  background: url(/static/img/banner-recetario.jpg) center/cover no-repeat;
}
.lugar-el[data=degustacionQuesos]{
  background: url(/static/img/banner-degustacionQuesos.jpg) center/cover no-repeat;
}

.plum-border[data="oleoturismo"]::before{
  border-color: rgba(255,255,255,.4)
}
.plum-border[data="degustacionQuesos"]::before{
  border-color: rgba(255,255,255,.4)
}
.plum-border[data="enoturismo"]::before,
.plum-border[data="ruta_cervantina"]::before{
  border-color: $mud-brown-40;
}

.launched {
  .title.-ghost{
    transform: translateY(8px);
    opacity: .5;
  }
  .lugar-el{
    opacity: 1;
    .btn{
      transform: translateY(0);
      opacity: 1;
    }
  }
}

@media screen and (max-width:769px){
  .lugar-el{
    &[data=ruta_cervantina]{
      .btn{
        font-size: 11px;
      }
    }
  }
}


@media screen and (max-width: 600px){

  .lugar-el{
    width: 100%;
    height: 33vh;
  }

  .launched .title.-ghost{
    transform: translateY(-12px);
  }
}


</style>



// WEBPACK FOOTER //
// src/components/parts/otras-experiencias.vue